import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import mergeThemeStyles from '../theme/mergeThemeStyles';
import themePropType from '../utils/themePropType';
import { interactionPropTypes } from '../utils/types';
import { listItemButtonTheme } from './theme/listItemButtonTheme';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled.button.withConfig({
  displayName: "VizExListItemButton__Container",
  componentId: "sc-10yr9az-0"
})(["", ""], ({
  theme
}) => mergeThemeStyles({
  component: 'ListItemButton',
  defaultStyles: listItemButtonTheme,
  theme
}));
const VizExListItemButton = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(Container, Object.assign({}, props, {
    ref: ref
  }));
});
VizExListItemButton.displayName = 'VizExListItemButton';
VizExListItemButton.propTypes = Object.assign({
  alignItems: PropTypes.oneOf(['center', 'flex-start']),
  autoFocus: PropTypes.bool,
  children: PropTypes.node,
  disableGutters: PropTypes.bool,
  disablePadding: PropTypes.bool,
  ordered: PropTypes.bool,
  theme: themePropType
}, interactionPropTypes);
export default VizExListItemButton;